// src/routes/AppRoutes.js
import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import ProtectedRoutes from "./ProtectedRoutes";
import ServicesLayout from "../Layout/ServicesLayout";
import { privateRoutes, publicRoutes } from "./routes";

const AppRoutes = () => {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element}>
            {route.children && route.children.map((child, idx) => (
              <Route
                key={idx}
                path={child.path}
                index={child.index}
                element={child.element}
              />
            ))}
          </Route>
        ))}

        {/* Private Routes */}
        {privateRoutes.map((route, index) => {
          const routeElement = (
            <ProtectedRoutes
              allowedRoles={route.allowedRoles || []}
              serviceKey={route.serviceKey}
              dynamicRoleMembership={route.dynamicRoleMembership}
              requiredPermission={route.requiredPermission}
            >
              <ServicesLayout serviceKey={route.serviceKey}>
                {route.element}
              </ServicesLayout>
            </ProtectedRoutes>
          );

          return (
            <Route key={index} path={route.path} element={routeElement}>
              {/* Level 1 Children */}
              {route.children?.map((childRoute, childIndex) => {
                const childElement = (
                  <ProtectedRoutes
                    allowedRoles={childRoute.allowedRoles || route.allowedRoles || []}
                    requiredPermission={childRoute.requiredPermission}
                    serviceKey={childRoute.serviceKey || route.serviceKey}
                  >
                    {childRoute.element}
                  </ProtectedRoutes>
                );

                if (childRoute.index) {
                  return (
                    <Route
                      key={childIndex}
                      index
                      element={childElement}
                    />
                  );
                }

                return (
                  <Route
                    key={childIndex}
                    path={childRoute.path}
                    element={childElement}
                  >
                    {/* Level 2 Children (Accounts children) */}
                    {childRoute.children?.map((nestedChild, nestedIndex) => {
                      const nestedElement = (
                        <ProtectedRoutes
                          allowedRoles={nestedChild.allowedRoles || childRoute.allowedRoles || route.allowedRoles || []}
                          requiredPermission={nestedChild.requiredPermission}
                          serviceKey={nestedChild.serviceKey || childRoute.serviceKey || route.serviceKey}
                          requiresInternalUser={nestedChild.requiresInternalUser}
                        >
                          {nestedChild.element}
                        </ProtectedRoutes>
                      );

                      if (nestedChild.index) {
                        return (
                          <Route
                            key={nestedIndex}
                            index
                            element={nestedElement}
                          />
                        );
                      }

                      return (
                        <Route
                          key={nestedIndex}
                          path={nestedChild.path}
                          element={nestedElement}
                        >
                          {/* Level 3 Children (FPC/Vendor/Products children) */}
                          {nestedChild.children?.map((deepChild, deepIndex) => {
                            const deepElement = (
                              <ProtectedRoutes
                                allowedRoles={deepChild.allowedRoles || nestedChild.allowedRoles || childRoute.allowedRoles || route.allowedRoles || []}
                                requiredPermission={deepChild.requiredPermission}
                                serviceKey={deepChild.serviceKey || nestedChild.serviceKey || childRoute.serviceKey || route.serviceKey}
                              >
                                {deepChild.element}
                              </ProtectedRoutes>
                            );

                            if (deepChild.index) {
                              return (
                                <Route
                                  key={deepIndex}
                                  index
                                  element={deepElement}
                                />
                              );
                            }

                            return (
                              <Route
                                key={deepIndex}
                                path={deepChild.path}
                                element={deepElement}
                              />
                            );
                          })}
                        </Route>
                      );
                    })}
                  </Route>
                );
              })}
            </Route>
          );
        })}

        <Route path="*" element={<div>404 Page Not Found - Path: {window.location.pathname}</div>} />
      </Routes>
    </React.Suspense>
  );
};

export default AppRoutes;